module.exports = __webpack_public_path__ + "img/zanwufajieqian.97c11dc8.png";